<div class="card">
  <div class="card-body">
   <form (ngSubmit)="onSubmit()" enctype="multipart/form-data">
  <div class="row">
    <!-- 🕌 Arabic Name -->
    <div class="col-sm-4">
      <div class="mb-3">
        <label class="form-label">{{ 'MENU.DASHBOARD.name_ar' | translate }}</label>
        <input
          type="text"
          class="form-control"
          placeholder="{{ 'MENU.DASHBOARD.enter_name_ar' | translate }}"
          [(ngModel)]="formData.name_ar"
          name="name_ar"
          required
        />
        <div *ngIf="!formData.name_ar" class="text-danger small mt-1">
          {{ 'MENU.DASHBOARD.name_ar_required' | translate }}
        </div>
      </div>
    </div>

    <!-- 🌐 English Name -->
    <div class="col-sm-4">
      <div class="mb-3">
        <label class="form-label">{{ 'MENU.DASHBOARD.name_en' | translate }}</label>
        <input
          type="text"
          class="form-control"
          placeholder="{{ 'MENU.DASHBOARD.enter_name_en' | translate }}"
          [(ngModel)]="formData.name_en"
          name="name_en"
          required
        />
        <div *ngIf="!formData.name_en" class="text-danger small mt-1">
          {{ 'MENU.DASHBOARD.name_en_required' | translate }}
        </div>
      </div>
    </div>
  </div>

  <!-- 💾 Submit -->
  <div class="row">
    <div class="col-sm-4">
      <div class="mb-3 d-flex justify-content-start">
        <button type="submit" class="btn" style="background-color: #cca44c !important; color: #fff;">
          {{ 'MENU.DASHBOARD.add' | translate }}
        </button>
      </div>
    </div>
  </div>
</form>
  </div>
</div>
